import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import {Dropdown, DropdownButton} from "react-bootstrap";
import OutboundLink from "../../OutboundLink";
import _ from "lodash";
import {naturalSort} from "../../../lib/utils";
import { generateExternalLinks } from "../../../lib/links";
import {inject, observer} from "mobx-react";


// "Green" links
const ExternalLinks = ({links = []}) => {

  const [groupedLinks, setGroupedLinks] = useState({});
  useEffect(() => {
    setGroupedLinks(_.groupBy(links.filter(x => x.title && x.url), "title"));
  }, [links]);

  if (!links?.length) {
    return null;
  }

  const linksList = Object.keys(groupedLinks).sort().map(groupName => {
    const linkGroup = groupedLinks[groupName];
    if (linkGroup.length === 1) {
      return linkGroup.map((link) => {
        const url = link.url;
        const handleClick = e => e;
        return (
          <OutboundLink
            key={groupName}
            className="source-link"
            title={link.description}
            href={url}
            onClick={handleClick}
          >
            {link.title}
          </OutboundLink>
        );
      });
    } else {
      // dropdown link set
      linkGroup.sort((a, b) => {
        return naturalSort(a.externalID, b.externalID);
      });
      return (
        <Dropdown
          key={groupName}
          drop="down"
          className="grouped-source-links source-link"
        >
          <Dropdown.Toggle variant="secondary" id={`dropdown-${groupName}`}>
            {groupName}
          </Dropdown.Toggle>
          <Dropdown.Menu
            popperConfig={{
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [0, 8],
                  },
                },
                {
                  name: 'preventOverflow',
                  options: {
                    boundary: 'viewport',
                    padding: 8,
                  },
                },
                {
                  name: 'flip',
                  options: {
                    fallbackPlacements: ['up', 'down'],
                    boundary: 'viewport',
                    padding: 8,
                  },
                },
              ],
            }}
          >
            {linkGroup.map(({ url, title, externalID }) => (
              <Dropdown.Item key={externalID} href={url} target="_blank" title={title}>
                {externalID}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      );
    }
  });
  return (<div className={"source-links"}>{linksList}</div>);
};

ExternalLinks.propTypes = {
  links: PropTypes.array.isRequired,
};

const _MDExternalLinks = (props) => {
  const {entity, searchSessionStore: {datasets}} = props;
  if (!entity.links && Object.keys(datasets).length > 0) {
    entity.links = generateExternalLinks(entity, datasets);
  }
  return (<ExternalLinks links={entity.links || []} datasets={datasets}/>);
}

export const MDExternalLinks = inject("searchSessionStore")(observer(_MDExternalLinks));
